var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.402,
    height: 17.969,
    viewBox: "0 0 15.402 17.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106773",
    "data-name": "Group 106773",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_21",
    "data-name": "Layer 21",
    d: "M19.4,18.685a1.283,1.283,0,0,1-1.283,1.283H5.283A1.283,1.283,0,0,1,4,18.685V3.283A1.283,1.283,0,0,1,5.283,2h7.746a.6.6,0,0,1,.6.6v3.9a1.283,1.283,0,0,0,1.283,1.283H18.8a.59.59,0,0,1,.6.6C19.4,11.376,19.4,18.685,19.4,18.685ZM15.038,6.492h3.684a.128.128,0,0,0,.09-.218L15.128,2.59a.128.128,0,0,0-.218.09V6.364A.128.128,0,0,0,15.038,6.492Z",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.4ec97e413c727bec30e9c6c252a189de.svg";
export { ForwardRef as ReactComponent };